import { render } from "./SidebarAdmin.vue?vue&type=template&id=19e821fa&scoped=true"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js"

import "./SidebarAdmin.vue?vue&type=style&index=0&id=19e821fa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e821fa"]])

export default __exports__